import './style.scss'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'

/** Lista adresów z etykietą źródła — wspólna dla konta i checkoutu */
export const RecipientsList = ({ recipients = [] }) => {
  const { t } = useTranslation()
  return recipients.length > 0
    ? recipients.map(({ email, sourceLabel }) => <div key={email}>
      <span>{email}</span>
      {sourceLabel && <span className='invoiceRecipients__source'>{sourceLabel}</span>}
    </div>)
    : <div>{t('account.none')}</div>
}

/**
 * Podgląd „Faktury trafią do” + przycisk edycji.
 * @param {{ settings?: { recipients?: { email: string, sourceLabel?: string }[], canEdit?: boolean }, companyId?: string }} props
 */
const Recipients = ({ settings, companyId }) => {
  const { t } = useTranslation()
  const { openPopup } = usePopupState()

  if (!settings) return null

  const recipients = Array.isArray(settings.recipients) ? settings.recipients : []
  const canEdit = settings.canEdit !== false
  // bez dodatkowych adresów zachęcamy do dodania, z adresami — do zmiany
  const hasExtraEmails = Array.isArray(settings.invoiceEmails) && settings.invoiceEmails.length > 0

  return (
    <div className='group'>
      <div>
        <div className='element__title'>{t('account.invoiceRecipients.sendTo')}</div>
        <div className='element__desc invoiceRecipients__preview'>
          <RecipientsList recipients={recipients} />
        </div>
        {!canEdit && <div className='invoiceRecipients__hint --left'>{t('account.invoiceRecipients.readOnly')}</div>}
      </div>

      {canEdit && <div
        className='element__title'
        onClick={() => openPopup({ type: 'editInvoiceRecipients', props: { companyId } })}
      >{t(hasExtraEmails ? 'account.invoiceRecipients.change' : 'account.invoiceRecipients.add')}</div>}
    </div>
  )
}

export default Recipients
